<template>
    <div style="background: linear-gradient(180deg, #ffffff 0%, #e6e2fe 60%);" class="py-12">
        <ContentWrapper class=" text-center">
            <div class="text-3xl font-headings">Built for Flexible Deployments</div>

            <div class="py-4 mx-auto max-w-3xl">
                The most flexible badge printing solutions on the market. Setup a registration area that matches your requirements, hardware, staff, workflow, attendees etc. Combine any methods to suit your needs.
            </div>

            <div class="grid grid-cols-4 gap-6 mt-8">
                <div v-for="(deployment, index) in deployments" :key="index" class="p-4 bg-white rounded-lg shadow-md">
                    <div class="font-semibold mb-1">{{ deployment.title }}</div>
                    <div class="text-sm text-gray-600">{{ deployment.description }}</div>
                </div>
            </div>
            
        </ContentWrapper>
    </div>
</template>
<script setup>
import ContentWrapper from '../../Layouts/ContentWrapper.vue';

const deployments = [
    {
        title: 'Self Service Kiosk',
        description: 'Search, Scan QR codes from emails, prints or the app. Register onsite site for walk ups'
    },
    {
        title: 'Staff Assisted',
        description: 'Using the App or CMS, staff can assist attendees with their badges, searching updating and printing directly'
    },
    {
        title: 'Registration Desk',
        description: 'Laptop or tablet based registration desk, allowing staff to share hardware and manage flow onsite'
    },
    {
        title: 'Pre Printed Badges',
        description: 'Generate print ready files with optional bleed and crop marks'
    }
]
</script>